import './UpcomingWebinars.css'
import EventBlock from "./EventBlock";

import ad_flyer from './data/ad_flyer.jpg'
import ad_flyer_pdf from './data/Flyer_CA_advertisement_farmers_Final.pdf'
import DiscoverMore from "../../../Controller/Buttons/DiscoverMore";
import {useHistory} from "react-router-dom";
import persistToggleMenu from "../../Navbar/persistToggleMenu";
import home_goat from './data/home-goat.jpg'
import goat_day_1 from './data/GoatDay_2023_p1.png'
import goat_day_2 from './data/GoatDay_2023_p2.png'

import UpcomingDetails from './UpcomingDetails.js';

const UpcomingWebinars = () => {
    const hist = useHistory();

    const mailTo = (e) => {
        window.location = "mailto:" + e.target.textContent
    }

    return (
        <div id = 'upcoming-webinars'>
            <h1> Upcoming Events </h1>
            <div className= 'flyer-container'>
                <div className='left_col'>
                    <UpcomingDetails title='Stay tuned for future species-specific webinars on swine and small ruminants this Fall!' source={home_goat} />
                    <UpcomingDetails 
                        title=' On-farm visits for developing customized biosecurity plans have now ended, but stay tuned for their return in 2023! If you are interested, please contact:' 
                        description={<ul className='contact-list'>
                                    <li>Alda Pires at <a href="mailto:apires@ucdavis.edu">apires@ucdavis.edu</a> if you are based in California</li>
                                    <li>Ragan Adams at <a href="mailto:ragan.Adams@colostate.edu">ragan.Adams@colostate.edu</a> if you are based in Colorado</li>
                                    <li>Craig McConnel at <a href="mailto:mcconnel@wsu.edu">cmcconnel@wsu.edu</a> if you are based in Washington</li>
                                </ul> }
                    />
                </div>
                {/* <div className='right_col'></div> */}
                

                {/*<iframe src={ad_flyer_pdf}  height="100%" width="100%" />*/}
                

                {/*<object  data= {ad_flyer_pdf} type="application/pdf">*/}
                {/*    <iframe src={ad_flyer_pdf} title ='hi'  height="100%" width="100%" />*/}
                {/*    <embed src= {ad_flyer_pdf} type="application/pdf" />*/}
                {/*</object>*/}

                {/* <div className= 'flyer-img-container' onClick = {() => window.open(ad_flyer_pdf, "_")}>
                    <img src = {ad_flyer} alt = "ad_flyer" />
                </div> */}

                


                
            </div>

            {/*<div className="scrollable-events">*/}
                {/*<EventBlock day = '04' month = 'January 2022'*/}
                {/*            title = 'Course Introduction & General Biosecurity Principles'*/}
                {/*            type = 'Webinar 1'*/}
                {/*            location = 'Live'/>*/}

                {/*<div className = 'alert'*/}
                {/*    style = {{*/}
                {/*        color: '#f7c35f',*/}
                {/*        fontSize: "2rem",*/}
                {/*    }}*/}
                {/*    >*/}
                {/*    Stay tuned for future webinars!*/}
                {/*</div>*/}
            {/*</div>*/}

            {/*<div className= 'btn-wrapper'>*/}
            {/*    <DiscoverMore name = "Register Here" url = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_80WFZOUUBuE6fFI"/>*/}
            {/*</div>*/}
        </div>

    )
}

export default UpcomingWebinars;